<script lang="ts" setup>
const route = useRoute()

const layoutMeta = computed(() => {
  return {
    showFooter: false,
    showHeader: true,
    ...route.meta.simple,
  }
})
</script>

<template>
  <v-main>
    <slot v-if="layoutMeta.showHeader" name="header">
      <site-header logo-only />
    </slot>
    <div class="content">
      <slot />
    </div>
    <slot v-if="layoutMeta.showFooter" name="footer">
      <site-footer />
    </slot>
  </v-main>
</template>

<style lang="scss" scoped>
.content {
  height: 100%;
  margin: 0 auto;
}
</style>
